import { postHttp } from './fetchApi';
import { Newsletter } from '@/http/Newsletter' 

// Custom fields on the Address element layout must be submitted nested under `fields`, not as top-level attributes
const ADDRESS_CUSTOM_FIELDS = ['addressTitle', 'addressPhone', 'addressNotes'];

export const Address = {

    add(data){
        var formData = new FormData();
        formData.append('action', 'commerce/cart/update-cart');
        Object.entries(data).forEach(([key, value]) => {
            const paramKey = ADDRESS_CUSTOM_FIELDS.includes(key) ? `fields][${key}` : key;
            formData.append(`shippingAddress[${paramKey}]`, value);
            formData.append(`billingAddress[${paramKey}]`, value);
        });
        formData.append('email', data.email);
        formData.append('gatewayId', 2);
        if(data.newsletter){
            //send subscription
            Newsletter.add(data.email, "testliste");
        }
        return postHttp('/', formData);
    },
    addInOrder(data){
        var formData = new FormData();
        formData.append('action', 'commerce/cart/update-cart');
        Object.entries(data).forEach(([key, value]) => {
            formData.append(`${key}`, value);
        });
        if(data.newsletter){
            //send subscription
            Newsletter.add(data.email, "testliste");
        }
        return postHttp('/', formData);
    }


}
